<ion-card>
  <ion-card-content>
    <ion-grid class="ion-no-padding">
      <ion-row>
        <ion-col size="6">
          <ion-skeleton-text
            [animated]="true"
            style="width: 50%; height: 1rem"
          ></ion-skeleton-text>
          <ion-skeleton-text
            [animated]="true"
            style="width: 66%; height: 0.75rem"
          ></ion-skeleton-text>
          <ion-skeleton-text
            [animated]="true"
            style="width: 40%; height: 0.75rem"
          ></ion-skeleton-text>
        </ion-col>
        <ion-col size="6">
          <ion-skeleton-text
            [animated]="true"
            style="width: 50%; height: 1rem; justify-self: end"
          ></ion-skeleton-text>
          <ion-skeleton-text
            [animated]="true"
            style="width: 40%; height: 0.75rem; justify-self: end"
          ></ion-skeleton-text>
          <ion-skeleton-text
            [animated]="true"
            style="width: 66%; height: 0.75rem; justify-self: end"
          ></ion-skeleton-text>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>
